<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="isRouterAlive&&!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { Loading } from 'vant';
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  }
}
</script>

<style>
  @import url("assets/css/main.css");
  .arrow_link{background: url(../static/img/arrow.png)no-repeat center;width: 7px;height: 11px;background-size: 7px 11px;}
  *{font-family:PingFangSC;}
</style>



// WEBPACK FOOTER //
// src/App.vue